import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ITestData, ITopicTests } from './models';

interface IStore {
  test: ITestData | null;
  currentQuestionIndex: number;
  testInfo: ITopicTests | null;
  isAnswered: boolean;
  isCorrectAnswer: boolean;
  selectedOption?: number | null;
}

const initialState: IStore = {
  test: null,
  currentQuestionIndex: 0,
  testInfo: null,
  isAnswered: false,
  isCorrectAnswer: false,
  selectedOption: null
};

const topicTest = createSlice({
  name: 'topic-test',
  initialState,
  reducers: {
    setTestData(state, action: PayloadAction<ITestData>) {
      state.test = action.payload;
    },
    setTestInfo(state, action: PayloadAction<ITopicTests>) {
      state.testInfo = action.payload;
    },
    setIsAnswered(state, action: PayloadAction<boolean>) {
      state.isAnswered = action.payload;
    },
    setCurrentQuestionIndex(state, action: PayloadAction<number>) {
      state.currentQuestionIndex = action.payload;
    },
    setIsCorrectAnswer(state, action: PayloadAction<boolean>) {
      state.isCorrectAnswer = action.payload;
    },
    setSelectedOption(state, action: PayloadAction<number | null>) {
      state.selectedOption = action.payload;
    },
    clearTest() {
      return initialState;
    }
  }
});

export const {
  setTestData,
  setTestInfo,
  setIsAnswered,
  setCurrentQuestionIndex,
  setIsCorrectAnswer,
  setSelectedOption,
  clearTest
} = topicTest.actions;
export const topicTestReducer = topicTest.reducer;
